import { TranslateService } from '@ngx-translate/core';
import { FeatureFlagsService } from './core/services/feature-flags.service';
import { AuthService } from './core/services/auth.service';
import { catchError, of, firstValueFrom } from 'rxjs';

/**
 * Application initialization function for standalone app.
 * Initializes i18n and validates BFF session.
 * Returns a Promise that resolves when initialization is complete.
 *
 * Note: BFF URL is configured statically per environment via window.envData.envConfig.bffUrl.
 * The BFF is registered in TRex/TRoX for backend service discovery, but frontend uses
 * the direct static URL injected at deployment time.
 */
export function appInit(
  translateService: TranslateService,
  authService: AuthService,
  featureFlagsService: FeatureFlagsService
) {
  return async () => {
    // Initialize translation service
    translateService.setDefaultLang('en-US');
    translateService.use('en-US');

    try {
      // Try to validate BFF session (optional - won't block app if it fails)
      const user = await firstValueFrom(
        authService.validateSession().pipe(
          catchError(error => {
            console.error(
              '[AppInit] No active BFF session:',
              error.message ?? error
            );
            return of(null);
          })
        )
      );

      if (user?.email) {
        try {
          await featureFlagsService.identifyUser({
            id: user.id,
            email: user.email,
          });
        } catch (error) {
          console.error(
            '[AppInit] LaunchDarkly user identification failed:',
            error
          );
        }
      }
    } catch (error) {
      console.error('[AppInit] Initialization error (non-blocking):', error);
      // Don't block app initialization on errors
    }
  };
}
